/**
 * 새벽기도회 설교 페이지
 */

import React from 'react';
import { SermonList } from '../components/SermonList';

export const DawnSermon: React.FC = () => {
  return <SermonList sermonType="dawn" title="새벽기도회" />;
};
